import Vue from 'vue'
import VueRouter from 'vue-router'
import AboutUs from '../views/a_AboutUs.vue'
import ExpertTeam from '../views/c_ExpertTeam.vue'
import DoctorTeam from '../views/c_doctorTeam.vue'
import HealthIntro from '../views/d_HealthIntro.vue'
import PhysicalExamination from '../views/d_PhysicalExamination'
import vipPE from '../views/d_vipPE'
import artile from '../views/z_artile'
import onlineYY from '../views/z_onlineYY'
import news from '../views/z_news'







Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'AboutUs',
    component: AboutUs
  },
  {
    path: '/ExpertTeam',
    name: 'ExpertTeam',
    component: ExpertTeam
  },
  {
    path: '/DoctorTeam',
    name: 'DoctorTeam',
    component: DoctorTeam
  },
  {
    path: '/HealthIntro',
    name: 'HealthIntro',
    component: HealthIntro
  },
  {
    path: '/PhysicalExamination',
    name: 'PhysicalExamination',
    component: PhysicalExamination
  },
  {
    path: '/vipPE',
    name: 'vipPE',
    component: vipPE
  },
  {
    path: '/artile',
    name: 'artile',
    component: artile
  },
  {
    path: '/onlineYY',
    name: 'onlineYY',
    component: onlineYY
  },
  {
    path: '/news',
    name: 'news',
    component: news
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0, behavior: 'instant' }
  }
})

router.beforeEach((to, from, next) => {
  document.body.style.overflow = 'hidden'
  next()
})

router.afterEach(() => {
  document.body.style.overflow = ''
  window.scrollTo(0, window.scrollY)
})

export default router
